export const assessment_update = {
  pre_update_changes_filename:
    "Pre_Atualizacao_{{preVersion}}_para_{{postVersion}}_{{assessment}}_{{tenant}}_{{dateTime}}.xlsx",
  post_update_changes_filename:
    "Pos_Atualizacao_{{preVersion}}_para_{{postVersion}}_{{assessment}}_{{tenant}}_{{dateTime}}.xlsx",
  "Are_you_sure_you_want_to_migrate?": "Tem certeza de que deseja migrar?",
  Assessment_Update_Dry_Run: "Atualização de Avaliação",
  Assessment_Update_List: "Lista de Atualização de Avaliações",
  Back_to_list: "Voltar à lista",
  Completed: "Concluído",
  Created: "Criado",
  Current_protocol_set_mapping_version: "Versão Atual do Mapeamento de Protocolo",
  Deleted: "Excluído",
  Download_JSON: "Baixar JSON",
  Dry_Run: "Execução de teste",
  Has_data: "Possui dados",
  Inactive: "Inativo",
  Is_renamed: "Renomeado",
  Migrate: "Migrar",
  Migrated: "Migrado",
  No_changes: "Sem alterações",
  No_changes_needed: "Nenhuma alteração necessária",
  Protocol_Question_Name: "Nome da Pergunta do Protocolo",
  Protocol_Question_New_Name: "Novo Nome da Pergunta do Protocolo",
  Protocol_Question_Old_Name: "Nome Antigo da Pergunta do Protocolo",
  protocol_set_changes: "Alterações do conjunto de protocolos",
  Site_name: "Nome do site",
  Stakeholder_Report: "Relatório de partes interessadas",
  Technical_Report: "Relatório técnico",
  There_are_no_assessments_for_this_tenant: "Não há avaliações para este locatário",
  To_create: "Para criar",
  To_delete: "Para excluir",
  To_migrate: "Para migrar",
  Update: "Atualizar",
  Upgrade_to_latest: "Atualizar para a versão mais recente",
  assessment_is_already_updated: "A avaliação já está atualizada",
  show_history: "Mostrar histórico",
} as const;
